var exports = {
  "m": "LoadableComponent.module__inline___QUh6ZX",
  "p": "LoadableComponent.module__inlineIcon___QUh6ZX",
};

module.exports = exports;
